import { render, staticRenderFns } from "./Processesn.vue?vue&type=template&id=3a934f97&"
import script from "./Processesn.vue?vue&type=script&lang=js&"
export * from "./Processesn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports